import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import "@/App.css";
import { PageHeader, Gallery, EgyptianScale } from "@/sections";

export default function FlutesPage() {
  const [content, setContent] = useState(null);
  const [items, setItems] = useState([]);

  useEffect(() => {
    Promise.all([
      api.get("/site-content").then((r) => setContent(r.data)).catch(() => {}),
      api.get("/instruments?type=flute").then((r) => setItems(r.data)).catch(() => {}),
    ]);
  }, []);

  return (
    <div className="App">
      <Nav artisanName={content?.artisan_name || "Sacred Instruments"} />
      <PageHeader
        eyebrow="Breath · Song · Pharaoh Love Flutes"
        title="Pharaoh love flutes"
        subtitle="Hand-crafted in NZ Black Maire, Rata and Pohutukawa, finished with a polished brass ring framing a sacred Panamou (jade) insert. Tuned to the sacred Egyptian pentatonic scale — D, E, G, A, B. Every flute is one of a kind."
      />
      <Gallery items={items} emptyText="No flutes yet — add them from the admin panel." />
      <EgyptianScale />
      <Footer content={content || {}} />
    </div>
  );
}
